import { Annotation, Field as IField } from 'types'

export const Field = {
  fieldTypes: {
    CHECKBOX: 'checkbox',
    DATE: 'date',
    SIGNATURE: 'signature',
    TEXT: 'text',
  },
  fromAnnotation: (annotation: Annotation): IField => {
    return {
      _destroy: !!annotation._destroy,
      height: annotation.geometry.height,
      id: annotation.notPersisted ? undefined : annotation.data.id,
      inputType: annotation.data.inputType,
      name: annotation.data.text,
      page: annotation.data.pageNumber,
      userId: annotation.data.userId,
      width: annotation.geometry.width,
      x_coordinate: annotation.geometry.x,
      y_coordinate: annotation.geometry.y,
      isAutoFillDate: annotation.data.isAutoFillDate,
    }
  },
  toAnnotation: (field: any) => ({
    data: {
      hasDocumentsFields: field.hasDocumentsFields,
      id: field.id,
      inputType: field.inputType,
      pageNumber: field.page,
      text: field.name,
      userId: field.userId,
      isAutoFillDate: field.isAutoFillDate,
    },
    geometry: {
      height: field.height,
      type: 'RECTANGLE',
      width: field.width,
      x: field.xCoordinate,
      y: field.yCoordinate,
    },
    selection: {
      mode: 'SELECTING',
      showEditor: true,
    },
  }),
}
